module.exports = "https://static.wmbcdn.com/uniweb/images/5b594f48b4a5ee38542b8bc79dad3fca.svg";